import React, { useEffect, useState } from "react";

import { Spin,Pagination } from "antd";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import AppService from '../../../service/app_service'
import TopBarComponent from './../component/topbar_component'
import SecureTransactionComponent from './../component/secure_transaction_component'

const TransactionPage = () => {

    const [loading, setLoading] = useState(false);
    const [transactions, setTransactions] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalTransactionCount, setTotalTransactionCount] = useState(0);

    useEffect(() => {
        getTransactions(pageNumber);
        //eslint-disable-next-line
    }, []);

    const getTransactions = async (pageNumber) => {
        setLoading(true);
        AppService.getTransactions(pageSize, pageNumber).then(rec => {
            setLoading(false)
            if (rec.error) {
                // AuthenticationService.clearLocalstorage();
                // this.props.history.push('/');
            } else {
                setTransactions(rec.list)
                setTotalTransactionCount(rec.noOfRecords)
            }


        })
    }

    const changePage= (val) =>{
        setPageNumber(val)
        getTransactions(val);
    }

    const getStatus = (item) => {
        let status = "";
        if(item.acceptNegotiation == 0) {
            status = "Pending Sellers acceptance";
        }
        if(item.acceptNegotiation == 1) {
            status = "Transaction Accepted";
        }
        if(item.paymentConfirmation == 1) {
            status = "Payment made";
        }
        if(item.buyerConfirmation == 1) {
            status = "Product/Service delivered";
        }
        return status;
    }

    const getNextAction = (item) => {
        let status = "";
        if(item.acceptNegotiation == 0) {
            status = "";
        }
        if(item.acceptNegotiation == 1) {
            status = "Awaiting Buyer's Payment";
        }
        if(item.paymentConfirmation == 1) {
            status = "Awaiting Product/Service Delivery";
        }
        if(item.buyerConfirmation == 1) {
            status = "";
        }
        return status;
    }

    return (
        <div id="main-wrapper" className="admin-dashboard-demos" style={{ background: '#e0e8f3',minHeight: '700px' }} >
            <TopBarComponent />
            <div className="page-content">
                <div className="container">
                    <div className="card content-area">
                        <div className="card-innr">
                            <div className="card-head">
                                <h4 className="card-title">User Transactions</h4>
                            </div>
                            <div className="content-area card">
                                <div className="card-innr">
                                    <div className="card-head">
                                        <h4 className="card-title">What is an escrow?</h4>
                                    </div>
                                    <p>
                                    An escrow is a financial and legal agreement designed to protect Buyers and Sellers in a transaction. 
                                    For a fee, an independent third party holds payment until everyone fulfills their responsibilities in the transaction.
                                    With an escrow payment, the Seller will only receive the funds when the Buyer has received and accepted the products 
                                    and/or services that are part of the transaction. However, the Seller knows they will receive payment because 
                                    Oneorbit Technologies (Tradexsafely) is holding the funds on their behalf.
                                    </p>
                                    <SecureTransactionComponent />
                                </div>
                            </div>
                            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                <div className="table-wrap">
                                
                                <Spin spinning={loading}>
                                <table className="data-table dt-init user-tnx dataTable no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                        <thead>
                                            <tr className="data-item data-head" role="row">
                                                <th className="data-col dt-tnxno sorting_disabled" rowSpan={1} colSpan={1}>Asset</th>
                                                <th className="data-col dt-token sorting_disabled" rowSpan={1} colSpan={1}>Amount</th>
                                                <th className="data-col dt-usd-amount sorting_disabled" rowSpan={1} colSpan={1}>Created By</th>
                                                <th className="data-col dt-account sorting_disabled" rowSpan={1} colSpan={1}>Status</th>
                                                <th className="data-col dt-type sorting_disabled" rowSpan={1} colSpan={1}>
                                                    <div className="dt-type-text">View</div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            { transactions && transactions.length > 0 && transactions.map((item, i) => {
                                                    return<tr className="data-item odd" role="row" key={i}>
                                                <td className="data-col dt-tnxno">
                                                    <div className="d-flex align-items-center">
                                                        <div className={"data-state "+(item.status === "COMPLETED" ? 'data-state-approved' : 'data-state-progress')}><span className="d-none">{item.status}</span></div>
                                                        <div className="fake-class"><span className="lead tnx-id">{item.name}</span><span className="sub sub-date">{item.createdAt}</span></div>
                                                    </div>
                                                </td>
                                                <td className="data-col dt-token">
                                                    <span className="lead token-amount">&#8358; {parseFloat(item.amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>
                                                    
                                                </td>
                                                
                                                <td className="data-col dt-usd-amount">
                                                    <span className="lead amount-pay">{item.createdBy}</span>
                                                    <span className="sub sub-date">{item.createdAt}</span>
                                                </td>
                                                <td className="data-col dt-account">
                                                    <span className="lead user-info">{item.status}</span>
                                                    <span className="sub sub-date">{getStatus(item)}</span>
                                                    <span className="sub sub-date">{getNextAction(item)}</span>
                                                </td>
                                                <td className="tnx-type"><Link to={"/transaction/detail/"+item.ref}><span className={"" +(item.status === "COMPLETED" ? 'tnx-type-md badge badge-outline badge-success badge-md' : 'tnx-type-md badge badge-outline badge-warning badge-md')}  >View</span><span className="tnx-type-sm badge badge-sq badge-outline badge-success badge-md">P</span></Link> </td>
                                                
                                            </tr> }) }

                                            {transactions && transactions.length > 0 && <tr>
                                                <Pagination onChange={changePage} pageSize={pageSize} defaultCurrent={pageNumber} current={pageNumber} total={totalTransactionCount} />
                                            </tr>}
                                        </tbody>
                                    </table>
                                    </Spin>
                                </div>
                                {/* <div className="row align-items-center">
                                    <div className="col-md-9">
                                        <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate">
                                            <ul className="pagination">
                                                <li className="paginate_button page-item previous disabled" id="DataTables_Table_0_previous"><a href="#" aria-controls="DataTables_Table_0" data-dt-idx={0} tabIndex={0} className="page-link">Prev</a></li>
                                                <li className="paginate_button page-item active"><a href="#" aria-controls="DataTables_Table_0" data-dt-idx={1} tabIndex={0} className="page-link">1</a></li>
                                                <li className="paginate_button page-item "><a href="#" aria-controls="DataTables_Table_0" data-dt-idx={2} tabIndex={0} className="page-link">2</a></li>
                                                <li className="paginate_button page-item next" id="DataTables_Table_0_next"><a href="#" aria-controls="DataTables_Table_0" data-dt-idx={3} tabIndex={0} className="page-link">Next</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-md-3 text-left text-md-right">
                                        <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">1 -5 of 8</div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        {/* .card-innr */}
                    </div>
                    {/* .card */}
                </div>
                {/* .container */}
            </div>
        </div>
    );

}
export default withRouter(TransactionPage);
